import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { digger } from '@cbre/digger';
import { EditingBoxStreamService } from '@shared/components/editing-box/editing-box-stream.service';
import { EditingBoxService } from '@shared/components/editing-box/editing-box.service';

@Component({
  selector: 'miq-editing-box-arrays',
  templateUrl: './editing-box-arrays.component.html',
  styleUrls: ['./editing-box-arrays.component.scss'],
  standalone: false,
})
export class EditingBoxArraysComponent implements OnInit {
  @Input() record: any;
  @Input() column: any;
  @Output() modified = new EventEmitter<any>();
  @Output() removeItem = new EventEmitter<any>();

  private fieldPath: string;
  private fieldName: string;
  private hasBeenModified = false;
  public attributeDetails: any[] = [];
  public deletedElements: any[] = [];

  constructor(
    private editingBoxService: EditingBoxService,
    private streamService: EditingBoxStreamService
  ) {}

  ngOnInit() {
    const { field } = this.column;
    this.fieldPath = field.split('/')[0];
    this.fieldName = field.split('/')[1];
    this.attributeDetails = [...digger(this.record, this.fieldPath)];
  }

  addArrayElement() {
    // Prevent the user to add new items if there are any empty record
    if (!this.hasEmptyValue()) {
      this.hasBeenModified = true;
      const newValue = { isNew: true, id: null }; // creating an entry with empty values
      // if there is an array element creating an object like that, if not get field from catalog
      if (this.attributeDetails && this.attributeDetails.length > 0) {
        Object.keys(this.attributeDetails[0]).forEach(key => {
          newValue[key] = null;
        });
      } else {
        newValue[this.fieldName] = '';
      }

      newValue.isNew = true;
      this.attributeDetails = [...this.attributeDetails, newValue];
    }
  }

  removeArrayElement(item) {
    this.hasBeenModified = true;
    this.deletedElements.push(this.attributeDetails.find(obj => obj === item));
    this.attributeDetails = this.attributeDetails.filter(obj => obj !== item);
  }

  private hasEmptyValue(): boolean {
    return this.attributeDetails.some(this.isEmpty.bind(this));
  }

  private isEmpty(value): boolean {
    // Is empty record when is new and fieldname is null undefined or empty
    return value.isNew && (value[this.fieldName] == null || value[this.fieldName] === '');
  }

  itemValueChanged(item, value) {
    this.hasBeenModified = true;
    item[this.fieldName] = value;
  }

  closeEditingBox() {
    if (this.hasBeenModified) {
      // Filter all the empty records and creates a new final list
      const finalList = this.attributeDetails.filter(x => !this.isEmpty(x));
      const { field } = this.column;
      const columnArray = [this.column];
      const fieldToBeUpdated = this.fieldName;
      finalList.forEach(item => {
        if (item.isNew && item.id == null && item[fieldToBeUpdated] !== null && item[fieldToBeUpdated] !== undefined) {
          this.modified.emit({ record: this.record, field, item, column: columnArray });
        }
      });
      this.deletedElements.forEach(item => {
        this.removeItem.emit({ item, column: [this.column] });
      });
      this.streamService.pushArrayAttributesStream(finalList);
    }
    this.editingBoxService.disposeBox();
  }
}
